import React, { useEffect, useRef, useState } from 'react'
import { Badge } from '../ui/badge'
import { calculaTiempoEnVivo, formatMmSs } from '../../lib/training/tiempoEnVivo'
import { getSeccionTipoLabel, getSeccionTipoColor } from '../../constants/seccionTipos'
import { alertaCambioSeccion, alertaAviso10seg } from '../../lib/training/alertas'

const EnVivoCuentaRegresiva = ({ estado, secciones }) => {
  const [tick, setTick] = useState(Date.now())
  const ultimoIdxRef = useRef(estado?.seccion_idx ?? null)
  const ultimoAvisoRef = useRef(null)

  useEffect(() => {
    const interval = setInterval(() => setTick(Date.now()), 250)
    return () => clearInterval(interval)
  }, [])

  const tiempo = calculaTiempoEnVivo({ estado, secciones, ahora: tick })

  useEffect(() => {
    if (estado?.seccion_idx !== undefined && estado.seccion_idx !== ultimoIdxRef.current) {
      if (ultimoIdxRef.current !== null && tiempo.iniciado) {
        alertaCambioSeccion()
      }
      ultimoIdxRef.current = estado.seccion_idx
      ultimoAvisoRef.current = null
    }
  }, [estado?.seccion_idx, tiempo.iniciado])

  useEffect(() => {
    if (!tiempo.iniciado || tiempo.pausado || tiempo.terminado) return
    if (tiempo.tiempoRestanteSeg === 10 && ultimoAvisoRef.current !== tiempo.seccionIdx) {
      alertaAviso10seg()
      ultimoAvisoRef.current = tiempo.seccionIdx
    }
  }, [tiempo.tiempoRestanteSeg, tiempo.iniciado, tiempo.pausado, tiempo.terminado, tiempo.seccionIdx])

  const seccion = secciones[tiempo.seccionIdx] || secciones[0]
  if (!seccion) return null
  const colorClasses = getSeccionTipoColor(seccion.tipo)

  return (
    <div className={`relative rounded-2xl border-2 ${colorClasses} p-6 text-center transition-colors`}>
      <h2 className="text-2xl font-bold uppercase tracking-wide">{seccion.nombre}</h2>
      <Badge variant="outline" className="mt-2">
        {getSeccionTipoLabel(seccion.tipo)}
      </Badge>

      <div className={`mt-6 text-7xl md:text-8xl font-mono font-bold ${
        tiempo.pausado ? 'opacity-50' : ''
      } ${
        tiempo.tiempoRestanteSeg <= 10 && tiempo.iniciado && !tiempo.pausado ? 'animate-pulse' : ''
      }`}>
        {formatMmSs(tiempo.tiempoRestanteSeg)}
      </div>
      <p className="text-sm text-foreground mt-1">
        {tiempo.pausado ? 'PAUSADO' : tiempo.iniciado ? 'restante' : 'sin iniciar'}
      </p>

      {seccion.descripcion && (
        <p className="mt-6 text-sm text-foreground italic max-w-md mx-auto">
          {seccion.descripcion}
        </p>
      )}
    </div>
  )
}

export default EnVivoCuentaRegresiva
